import React from 'react';
function GameOverMessage({ isCurrentPlayer, winner, onClose }) {
    const msgType = isCurrentPlayer ? 'success' : 'danger';
    const icon = isCurrentPlayer ? '🥳 🎉' : '😢';
    const text = isCurrentPlayer ? 'You have won!' : 'You have lost the game!';
    return (React.createElement("article", { className: `message is-${msgType}` },
        React.createElement("div", { className: "message-header" },
            React.createElement("p", null,
                "Game Over, ",
                isCurrentPlayer ? 'you are' : `${winner.username} is`,
                " the winner"),
            React.createElement("button", { className: "delete is-medium", "aria-label": "Close", onClick: onClose })),
        React.createElement("div", { className: "message-body" },
            React.createElement("h2", { className: "title is-1" },
                text,
                " ",
                icon),
            isCurrentPlayer ? React.createElement("p", null, "Congratulations!") : React.createElement("p", null, "Better luck next time"),
            React.createElement("button", { className: `button is-${msgType} mt-2`, onClick: onClose }, "Close message"))));
}
export default GameOverMessage;
